import React, { useEffect, useState } from "react";
import Modal from "../../../components/modal";
import axios from "axios";
import Swal from "sweetalert2";
import { API_URL } from "../../../utils/constant";

const CompanyHrmsSetupModal = ({
    show,
    onClose,
    heading,
    initialData,
    onSuccess,
}) => {
    const [formData, setFormData] = useState({
        company_id: localStorage.getItem("companyID"),
        master_type: "",
        name: "",
        values: "",
    });

    useEffect(() => {
        if (initialData) {
            setFormData({
                company_id: initialData.company_id,
                master_type: initialData.master_type,
                name: initialData.name,
                values: initialData.values || "",
            });
        }
    }, [initialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            ...formData,
            company_id: localStorage.getItem("companyID"),
        };

        try {
            if (initialData?.id) {
                await axios.put(
                    `${API_URL}/company-hrmd-system-setup/${initialData.id}`,
                    payload
                );
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "HRMS setup updated successfully",
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
            } else {
                await axios.post(`${API_URL}/company-hrmd-system-setup`, payload);
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "HRMS setup added successfully",
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
            }

            onClose();
            onSuccess();
        } catch (error) {
            Swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: error.response?.data?.message || "Something went wrong",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
            });
        }
    };


    return (
        <Modal show={show} onClose={onClose} heading={heading}>
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <label className="form-label">Master Type</label>
                        <input
                            type="text"
                            disabled
                            className="form-control"
                            name="master_type"
                            value={formData.master_type}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="col-md-6 mb-3">
                        <label className="form-label">Name</label>
                        <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {formData.master_type === 'Leave Type' && (<div className="col-md-12 mb-3">
                        <label className="form-label">Days per Year</label>
                        <input
                            type="number"
                            step={1}
                            className="form-control"
                            name="values"
                            value={formData.values}
                            onChange={handleChange}
                        />
                    </div>)}
                </div>

                <div className="d-flex justify-content-end">
                    <button
                        type="button"
                        className="btn btn-light me-2"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                        Save
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default CompanyHrmsSetupModal;
